import type { JSX } from 'react'
import { Avatar, MusicIcon } from '@buffer-mono/popcorn'
import { PostFields } from '@buffer-mono/reminders-config'
import { AiInfoIcon } from '~publish/legacy/composer/composer/components/post-preview/assets/instagram'
import {
  DotsIcon,
  PreviewAiMarker,
} from '~publish/legacy/composer/composer/components/post-preview/previews/Common/styles'
import type {
  InstagramContent,
  ProfilePreview,
} from '~publish/legacy/composer/composer/components/post-preview/previews/types'
import {
  CollaboratorAvatars,
  collaboratorPreviewName,
} from './CollaboratorAvatars'
import styles from '~publish/legacy/composer/composer/components/post-preview/previews/InstagramPreview/components/Post/Post.module.css'

export function FeedHeader({
  content,
  profile,
}: {
  content: InstagramContent
  profile: ProfilePreview
}): JSX.Element {
  const collaborators = content.isReminder
    ? []
    : (content.channelData?.instagram?.collaborators ?? [])
  const firstCollaborator = collaborators[0]
  const { avatar, username } = profile
  const locationName = content.channelData?.instagram?.service_geolocation_name
  const { isAiGenerated } = content
  const stickerMusic =
    content.isReminder && content.selectedStickers?.includes(PostFields.MUSIC)
      ? content.channelData?.instagram?.music
      : ''
  return (
    <div className={styles.header}>
      {firstCollaborator ? (
        <CollaboratorAvatars
          avatar={avatar}
          username={username}
          collaborator={firstCollaborator}
        />
      ) : (
        <Avatar data-testid="avatar" src={avatar} alt={username} size="small" />
      )}
      <div className={styles.usernameWrapper}>
        <span className={styles.username} translate="no">
          {collaboratorPreviewName(username, collaborators.length)}
        </span>
        <span className={styles.location} translate="no">
          {locationName || ''}
        </span>
        {stickerMusic && (
          <span className={styles.music}>
            <MusicIcon />
            Music
          </span>
        )}
        {isAiGenerated && (
          <PreviewAiMarker
            icon={<AiInfoIcon />}
            label="AI info"
            variant="inline"
            className={styles.aiMarker}
          />
        )}
      </div>
      <DotsIcon />
    </div>
  )
}
